import SubscriptionPie from "./SubscriptionPie";

export default SubscriptionPie;
